import { skillStepLockMs, type SkillDef } from '@jianghu/game-data';
import { INPUT_HZ, msToTicks, normalize, type MoveState } from '@jianghu/shared';

/**
 * Applies the movement-side effects of starting a technique: combo step selection, root (lock)
 * ticks and facing. Client prediction and the server call this identically on the same command
 * tick, so both agree on when the character can move or act again.
 */
export function applyCastToMoveState(
  move: MoveState,
  skill: SkillDef,
  aimX: number,
  aimZ: number,
): { step: number; lockMs: number } {
  const comboLen = skill.combo?.length ?? 0;
  const step = comboLen > 0 && move.comboTicks > 0 ? move.comboStep % comboLen : 0;
  const lockMs = skillStepLockMs(skill, step);
  move.rootTicks = msToTicks(lockMs, INPUT_HZ);
  if (comboLen > 0) {
    move.comboStep = step + 1;
    move.comboTicks = move.rootTicks + msToTicks(skill.comboWindowMs ?? 0, INPUT_HZ);
  }
  const aim = normalize(aimX, aimZ);
  if (aim.x !== 0 || aim.z !== 0) {
    move.fx = aim.x;
    move.fz = aim.z;
  }
  return { step, lockMs };
}
